import styled from 'styled-components'

export default styled.div`
  .footer-image {
    max-width: 12rem;
    max-height: 12rem;
  }

  .guarantee {
    font-weight: bold;
    font-size: 2.2rem;
  }

  .satisfaction {
    font-weight: 500;
    font-size: 1.8rem;
    text-align: center;
  }
`
